import React from 'react';
import { arrayOf, string, bool, func } from 'prop-types';
import classNames from 'classnames/bind';
import { Col, Image } from '@thd-olt-component-react/core-ui';
import { publish } from '../utils/publisher';
import styles from './SupplementalRecs.module.scss';

const cx = classNames.bind(styles);

const SupplementalTiles = ({
  productsData, schemaName, isDrawerShow, onClickShowDrawer
}) => {

  const handleImageClick = (idx) => publish({
    componentName: 'supplemental-recs',
    eventName: 'click',
    data: {
      position: idx + 1,
      schemaName
    }
  });

  const truncatedData = productsData?.filter((__, i) => i < 6);

  return (
    <>
      {
        truncatedData?.length
        && (
          <>
            {
              truncatedData.map((prod, idx) => {
                const imageUrl = prod?.product?.media?.images?.[0]?.url;
                const { productLabel } = prod?.product?.identifiers;
                const itemId = prod?.product?.itemId;

                return (
                  <Col
                    key={itemId}
                    fallback="6"
                    className={cx('supplemental-recs__product-tile-images')}
                  >
                    <meta data-prop="name" content={itemId} />
                    { isDrawerShow
                      ? (
                        <Image
                          src={imageUrl.replace('<SIZE>', '300')}
                          lazy
                          stretchy
                          alt={productLabel}
                          title={productLabel}
                          onClick={onClickShowDrawer}
                        />
                      )
                      : (
                        <a
                          href={prod?.product?.identifiers?.canonicalUrl}
                          onClick={() => handleImageClick(idx)}
                        >
                          <Image
                            src={imageUrl.replace('<SIZE>', '300')}
                            lazy
                            stretchy
                            alt={productLabel}
                            title={productLabel}
                          />
                        </a>
                      )}
                  </Col>
                );
              })
            }
          </>
        )
      }
    </>
  );
};

SupplementalTiles.propTypes = {
  productsData: arrayOf(Object),
  schemaName: string,
  isDrawerShow: bool,
  onClickShowDrawer: func
};

SupplementalTiles.defaultProps = {
  productsData: null,
  schemaName: '',
  isDrawerShow: null,
  onClickShowDrawer: () => {}
};

export { SupplementalTiles };